import { Injectable } from "@angular/core";
import { BackendParam, BackendService } from "@tg4/http-infrastructure/dist/src";
import { Observable } from "rxjs";
import { AttributeItem } from "../shared/interfaces/attribute-item";

@Injectable()
export class AttributesService {
    constructor(private _backEndService: BackendService) {}

    public searchAttributes(type: number, limit: boolean, onlyActiveAttributes: boolean): Observable<{ data: AttributeItem[] }> {
        const parameters: BackendParam[] = [
            { name: "type", value: type.toString() },
            { name: "limit", value: limit.toString() },
            { name: "onlyActiveAttributes", value: onlyActiveAttributes.toString() },
        ];
        return this._backEndService.get("searchAttributes", [], parameters);
    }

    public getUsedAttributeTypes(): Observable<{ data: any }> {
        return this._backEndService.get("getUsedAttributeTypes", []);
    }

    public getUserAttributes(id: string | null | undefined): Observable<any> {
        const params = [];
        if (id != null) {
            params.push({ 'name': 'userId', 'value': id });
        }
        return this._backEndService.get('getUserAttributes', [], params);
    }
}
